import { useEffect, useState } from "react";
import { Plus, X, Trash2 } from "lucide-react";
import api from "@/api";
import { toast } from "sonner";

const ROLES = [["admin", "Admin"], ["catalog_manager", "Catalog Manager"], ["order_manager", "Order Manager"], ["support", "Customer Support"], ["marketing", "Marketing"]];

export default function AdminUsers() {
  const [items, setItems] = useState(null);
  const [adding, setAdding] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "admin" });
  const [error, setError] = useState("");
  const load = () => api.get("/admin/users").then(({ data }) => setItems(data)).catch((e) => setError(e.friendlyMessage));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", f);
      toast.success("Staff account created");
      setAdding(false); setF({ name: "", email: "", password: "", role: "admin" });
      load();
    } catch (err) { toast.error(err.friendlyMessage); }
  };
  const del = async (id) => {
    if (!window.confirm("Remove this staff account?")) return;
    try { await api.delete(`/admin/users/${id}`); toast.success("Removed"); load(); }
    catch (err) { toast.error(err.friendlyMessage); }
  };

  if (error) return <div className="bg-white border border-[#8B1E21]/30 p-8 text-center text-[#8B1E21]" data-testid="users-forbidden">{error} — this area is restricted to Super Admin.</div>;
  return (
    <div data-testid="admin-users">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-serif text-3xl">Users & Roles</h1>
        <button onClick={() => setAdding(true)} data-testid="user-create-btn" className="tq-btn-dark !py-2.5"><Plus size={14} /> Add Staff</button>
      </div>
      {!items ? <div className="h-48 bg-white animate-pulse" /> : (
        <div className="bg-white border border-[#E5DEC9] divide-y divide-[#F4EFE6]">
          {items.map((u) => (
            <div key={u.id} className="p-4 flex items-center justify-between gap-3" data-testid={`user-row-${u.email}`}>
              <div>
                <p className="font-medium">{u.name}</p>
                <p className="text-xs text-[#9a938a]">{u.email}</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-[10px] font-bold uppercase tracking-wider bg-[#F4EFE6] px-2 py-1">{u.role.replace(/_/g, " ")}</span>
                {u.role !== "super_admin" && <button onClick={() => del(u.id)} aria-label="Remove user" className="text-[#8B1E21]"><Trash2 size={15} /></button>}
              </div>
            </div>
          ))}
        </div>
      )}
      {adding && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <form onSubmit={add} className="bg-white p-6 w-full max-w-sm space-y-3" data-testid="user-form">
            <div className="flex items-center justify-between"><p className="font-serif text-xl">Add Staff</p><button type="button" onClick={() => setAdding(false)} aria-label="Close"><X size={18} /></button></div>
            <input required placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="user-name" className="tq-input" />
            <input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="user-email" className="tq-input" />
            <input required minLength={8} type="password" placeholder="Password (min 8)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="user-password" className="tq-input" />
            <select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="user-role" className="tq-input bg-white">
              {ROLES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <button className="tq-btn-dark w-full" data-testid="user-save-btn">Create Account</button>
          </form>
        </div>
      )}
    </div>
  );
}
